import { z } from "zod"

export const QRResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
  campaignId: z.bigint().transform(String).nullable(),
  campaign: z
    .object({
      id: z.bigint().transform(String),
      name: z.string().nullable(),
    })
    .optional()
    .nullable(),
  scans: z.number().optional().nullable(),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
  archivedAt: z
    .date()
    .transform((value) => value?.toISOString())
    .optional()
    .nullable(),
  lastScannedAt: z
    .date()
    .transform((value) => value?.toISOString())
    .optional()
    .nullable(),
})

export const QRsResponseDataSchema = z.array(QRResponseDataSchema)
